<div class="container-fluid pl-0 pr-0 mr-0">
  <!-- <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div> -->
  <!--<div class="row">
    <div style="margin-top:10px; margin-bottom:-10px;">
      <h4><span style="padding-right:15px"></span> <i class="fa fa-file"></i>  <b>{{this.lblHeading}}</b></h4>
    </div>
  </div>
  <hr>-->
  <div *ngIf="!complianceDetailId"  class="modal fade" id="abc" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Document Uploaded</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-lg">

          <div style="width: 99%; height: 470px;">   
          <!-- <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;" ></pdf-viewer> -->
          <ng2-pdfjs-viewer     *ngIf="pdfSrc" [pdfSrc]='pdfSrc'         
          id='view1'         
          [externalWindow]="false"
          [downloadFileName]="'mytestfile.pdf'"                  
          [openFile]="false"
          [viewBookmark]="false"
          [download]="false" >
        </ng2-pdfjs-viewer>
          <ngx-loading [show]="isLoadingImg"></ngx-loading>
</div>  
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" data-dismiss="modal">Close</button>
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="complianceDetailId" class="modal fade" id="abc2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Document Uploaded</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-lg">

          <div style="width: 99%; height: 470px;">   
          <!-- <pdf-viewer *ngIf="pdfSrc" [src]="pdfSrc" [render-text]="true" style="display: block;" ></pdf-viewer> -->
          <ng2-pdfjs-viewer     *ngIf="pdfSrc" [pdfSrc]='pdfSrc'         
            id='view2'             
          [externalWindow]="false"
          [downloadFileName]="'mytestfile.pdf'"                  
          [openFile]="false"
          [viewBookmark]="false"
          [download]="false" >
        </ng2-pdfjs-viewer>
          <ngx-loading [show]="isLoadingImg"></ngx-loading>
</div>  
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" data-dismiss="modal">Close</button>
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
        </div>
      </div>
    </div>
  </div>

  
<ng-template #noFile>
  <div> 
  Oops, no file.
  </div>
</ng-template>

 
  <fieldset  style="width:100%;">
    <!-- <legend class="scheduler-border"><span class="sb-txt">Document Uploads</span> </legend> -->
    <div class="row" style="margin:20px auto;margin-bottom:0px !important;">

      <div class="col-md-12 p-0">
        <table id="vTypes" border="1" class="table tbl-stl scroll-table" style="padding-left:15px;">
          <thead class="thead-inverse tbl-hd-stl hgt-btn">
            <tr style="vertical-align:middle;" class="hgt-btn">
              <th>
                Document Type
              </th>
              <th style="vertical-align:middle;">
                File Name
              </th>
              <th style="text-align: center;">View File</th>
              <!-- <th style="vertical-align:middle;">
                Delete
              </th>
              <th style="vertical-align:middle;">
                Upload
              </th> -->
            </tr>
          </thead>
          <tr style="height: 10px !important;" *ngFor="let UserDocument of uploadedDocs   | paginate: { itemsPerPage: 5, currentPage: page }">
            <td>{{UserDocument.description}}</td>
            <td>{{UserDocument.file_name}}</td>
            <td style="text-align: center;">
              <!-- <span title="Delete Document" style="margin: 0%" class="btn btn-danger btn-sm" (click)="deleteDoc(UserDocument)"><i class="fa fa-trash-o fa-fw"></i></span> -->
              <span style="background-color:white" *ngIf="!complianceDetailId" title="View Document" style="margin: 0%" >
                <img title="View Document" class="file-upload-icon" src="/assets/visibility.png" alt="visibility"  aria-hidden="true" data-toggle="modal" data-target="#abc" (click)="viewDoc(UserDocument.shareId,UserDocument.document_link)"/></span>
              <span style="background-color:white" *ngIf="complianceDetailId" title="View Document" style="margin: 0%"  >
                <img title="View Document" class="file-upload-icon" src="/assets/visibility.png" alt="visibility"  aria-hidden="true" data-toggle="modal" data-target="#abc2" (click)="viewDoc(UserDocument.shareId,UserDocument.document_link)"/></span>
                  <button id="openModalButton" [hidden]="true" data-toggle="modal" data-target="#myModal">Open Modal</button>
            <!-- Modal --> 

          </tr>
          <tfoot>
            <tr *ngIf="UserDocuments.length > 4">
              <td colspan="4" class="rm-brd">
                <pagination-controls (pageChange)="page = $event" style="margin:0px;padding:0px;"></pagination-controls>
              </td>
            </tr>
            <tr *ngIf="uploadedDocs.length <= 0">
              <td colspan="4" class="rm-brd">
                <span class="text-info text-small">No Documents found.</span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!--<div class="col-12">
      <button title="Close this page" (click)="utility.landingPage()" type="button" id="btnClose" class="btn btn-md btn-primary pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-window-close-o"></i> Close</button>
      <button title="Go to the next page" *ngIf="utility.ctrlPages[acc.Fourth].next > -1" type="button" id="btnNext" (click)="utility.nextPage(acc.Fourth)" class="btn btn-md btn-success pull-right" style="width:18%; margin-left:10px; ">Submit <i class="fa fa-arrow-circle-right"></i></button>
      <button title="Save change(s)" type="submit" [disabled]="DocTypesList.length > 0" id="btnSave" class="btn btn-md btn-primary pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-save"></i> Save</button>
      <button *ngIf="utility.ctrlPages[acc.Fourth].previous > -1" title="Go to previous carrier account page" type="button" id="btnPrevious" (click)="utility.prevPage(acc.Fourth)" class="btn btn-md btn-info pull-right" style="width:18%; margin-left:10px; "><i class="fa fa-arrow-circle-left"></i> Previous</button>
    </div>-->

    </div>
  </fieldset>
</div>


<!-- <div class="col-12">
<button class="btn btn-md m-clr pull-right hd-btn mt-2" [disabled]="disableBtn" (click)="cancelApplication()" title="Cancel"  style="float: right !important;"><i class="fa fa-times"></i> Cancel</button>
  <button
class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
(click)="saveUploads()" title="Save & Continueto step 6" [disabled]="disableBtn" style="float: right !important;">
<i class="fa fa-save"></i> Save & Continue</button>
<div *ngIf="disableBtn" >
  <button
  class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2"
  routerLink="/permit/approval" title="Cancel"  style="float: right !important;">
  <i class="fa fa-times"></i> Back</button>
  </div>
</div> -->
<!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong">
  Launch demo modal
</button> -->












<div class="modal fade" id="addModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Upload Document</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <table>
          <th>
            Document Type
          </th>


          <tbody>
          <tr>
          <td>
            <select class="form-control select-auto"  [(ngModel)]="docTypeData" (change)="selectedDocType($event.target.value);isTrue = true" [ngStyle]="{'border-color': haserror && 'red'}"  title="Document Code">
              <option *ngFor="let type of categories" [ngValue]="type.id" disabled>Select Document Type</option>
              <option *ngFor="let type of doctypesCodes" [ngValue]="type"  >{{type.description}}</option>


            </select>
          </td>
          <td>
            <div >
              <!-- <label for="file">Choose File</label> -->
              <!-- <input [disabled]="!isTrue" class="form-control" type="file"
                     id="file"
                     (change)="handleFileInput($event)"> -->
          </div>
          </td>
          <!-- <td>
            <button type="button"><i
              class="fa fa-eye" aria-hidden="true" (click)="viewDoc(item.shareId,item.document_link)"></i></button>

          </td> -->
        </tr>
      </tbody>

        </table>
        <ngx-loading [show]="isLoadingImg"></ngx-loading>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-md m-clr pull-right hd-btn mr-2 mt-2 myButton" data-dismiss="modal">Close</button>
        <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
      </div>
    </div>
  </div>
</div>
<ngx-loading [show]="isLoading"></ngx-loading>
